var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qa-detail",style:({ paddingLeft: '24px' })},[_c('router-link',{attrs:{"to":'/resource/help/qa/list-' + this.arcitleData['categoryId']}},[_c('a-icon',{attrs:{"type":"left"}}),_vm._v("返回")],1),_vm._v(" "),_c('div',{staticClass:"news_title"},[_vm._v("\n    "+_vm._s(this.arcitleData && this.arcitleData["abstracts"]
        ? this.arcitleData["abstracts"]
        : "")+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(
      this.arcitleData && this.arcitleData['html'] ? this.arcitleData['html'] : ''
    )}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }